<template>
  <div class="home-page">
    <TopTitle title="首页" />

    <div class="home-page-tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">

        <!-- <el-tab-pane label="公司信息" name="first"> -->
        <div class="company-msg">
          <div class="line-div">公司信息</div>

          <div class="flex top-div">
            <div class="pic-div">
              <img :src="imgs.companyImg" width="76px" height="76px" />
            </div>
            <div class="info">
              <div class="flex">
                <div class="title-small">公司名称</div>
                <div class="text-content">{{ (info && info.companyCnName) ? info.companyCnName : '-' }}</div>
                <div class="approve" @click="goApprove" v-if="!(info && info.companyCnName)">
                  <el-link type="primary" :underline="false">立即认证</el-link>
                </div>
                <div class="approve" style="color: #000;cursor: auto;" v-else>{{ info.status == 0 ? '等待认证审核' : info.status == 10 ? '认证审核不通过' : info.status == 20 ? '审核通过' : info.status == 201 ? '账户信息重新审核中' : '账户信息重新认证失败' }}</div>
              </div>
              <div class="flex">
                <div class="title-small">企业电话</div>
                <div class="text-content">{{ (info && info.phone) ? info.phone : '-' }}</div>
              </div>
            </div>
          </div>
          <div class="center-div">
            <div class="line-div">专属销售</div>
            <div class="flex top-div" v-if="info && info.adminUserInfoVO && info.adminUserInfoVO.nickname">
              <div class="pic-div">
                <img v-if="(info.adminUserInfoVO && info.adminUserInfoVO.avatar)" :src="(info.adminUserInfoVO && info.adminUserInfoVO.avatar) ? info.adminUserInfoVO.avatar : ''" width="76px" height="76px" />
                <img v-else :src="imgs.userImg" width="76px" height="76px" />
                <div class="content-center update-div">修改</div>
              </div>
              <div class="info">
                <div class="flex">
                  <div class="title-small">销售</div>
                  <div class="text-content" v-if="info.adminUserInfoVO && info.adminUserInfoVO.nickname">{{ info.adminUserInfoVO.nickname ? info.adminUserInfoVO.nickname : '-' }}</div>
                  <div class="text-content" v-else>-</div>

                </div>
                <div class="flex">
                  <div class="title-small">手机号码</div>
                  <div class="text-content" v-if="info.adminUserInfoVO && info.adminUserInfoVO.phone">{{ info.adminUserInfoVO.phone ? info.adminUserInfoVO.phone : '-' }}</div>
                  <div class="text-content" v-else>-</div>
                  <!-- <el-popover trigger="hover" placement="top">
                      <div class="content-center">复制</div>
                      <div slot="reference" class="name-wrapper">
                        <i v-if="info.adminUserInfoVO && info.adminUserInfoVO.phone" @click="copy(info.adminUserInfoVO.phone ? info.adminUserInfoVO.phone : '-')" class="iconfont icon-a-fuzhi20 cursor-pointer" style="margin-left: 16px;color: #1170EB;font-size: 12px;" />
                      </div>
                    </el-popover> -->
                  <div class="name-wrapper">
                    <i v-if="info.adminUserInfoVO && info.adminUserInfoVO.phone" @click="copy(info.adminUserInfoVO.phone ? info.adminUserInfoVO.phone : '-')" class="iconfont icon-a-fuzhi20 cursor-pointer" style="color: #1170EB;font-size: 12px;" />
                  </div>

                </div>
                <div class="flex">
                  <div class="title-small">邮箱</div>
                  <div class="text-content" v-if="info.adminUserInfoVO && info.adminUserInfoVO.email">{{ info.adminUserInfoVO.email ? info.adminUserInfoVO.email : '-' }}</div>
                  <div class="text-content" v-else>-</div>
                  <!-- <el-popover trigger="hover" placement="top">
                      <div class="content-center">复制</div>
                      <div slot="reference" class="name-wrapper">
                        <i v-if="info.adminUserInfoVO && info.adminUserInfoVO.email" @click="copy(info.adminUserInfoVO.email ? info.adminUserInfoVO.email : '-')" class="iconfont icon-a-fuzhi20 cursor-pointer" style="margin-left: 16px;color: #1170EB;font-size: 12px;" />
                      </div>
                    </el-popover> -->
                  <div class="name-wrapper">
                    <i v-if="info.adminUserInfoVO && info.adminUserInfoVO.email" @click="copy(info.adminUserInfoVO.email ? info.adminUserInfoVO.email : '-')" class="iconfont icon-a-fuzhi20 cursor-pointer" style="color: #1170EB;font-size: 12px;" />
                  </div>

                </div>
              </div>
            </div>

            <div class="content-div" v-else>
              <el-empty :image="imgs.copy" description="暂无专属销售" />
            </div>
          </div>
          <div v-if="userData.companyUserStatus == 1">
            <div class="line-div">公司成员</div>

            <div class="content-left flex" v-if="(info && info.companyMember && info.companyMember.length > 0)">
              <div class="company-user-card" v-for="(item,index) in info.companyMember" :key="index">
                <div v-if="item.avatar" style="border-radius: 4px;overflow: hidden;">
                  <img :src="item.avatar" width="54px" height="54px" />
                </div>
                <div v-else style="border-radius: 4px;overflow: hidden;">
                  <img :src="imgs.userImg" width="54px" height="54px" />
                </div>
                <div class="txt">{{item.nickname}}</div>
              </div>
              <!-- 根据企业是否认证成功判断是否可以添加员工 -->
              <div class="company-user-card" @click="inviteShow" v-if="userData.companyStatus == 20 && userData.companyUserStatus == 1">
                <div class="add-img"></div>
                <div class="txt txt-hover">添加员工</div>
              </div>
              <div class="more" @click="goMember">
                <el-link type="primary" :underline="false">查看更多</el-link>
                <!-- <div class="dian"></div> -->
              </div>

            </div>

            <div class="content-div" v-else>
              <el-empty :image="imgs.copy" description="暂无成员" />
            </div>
          </div>
          <div class="bottom-img ">
            <img :src="imgs.homePage" width="100%" height="240px" style="padding-right: 1px;" />
            <el-button class="btn" @click="toWjx">咨询有礼</el-button>
          </div>
        </div>
        <!-- </el-tab-pane> -->

        <el-tab-pane label="消息中心" name="second" v-if="false">
          <div class="flex">
            <div class="mes-tab content-center" :class="msgActive ? 'mes-tab-active' : ''" @click="msgTab(true)">未读消息</div>
            <div class="mes-tab content-center" :class="!msgActive ? 'mes-tab-active' : ''" @click="msgTab(false)">已读消息</div>
          </div>
          <div class="content-left" style="margin-bottom: 16px;">
            <div>
              <img :src="imgs.reading" width="12px" height="12px" />
            </div>
            <div class="msg-btn">标为已读</div>
          </div>
          <div>
            <el-table ref="multipleTable" :data="tableData" :header-cell-style="{background:'#FAFAFA'}" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="50" align="center">
              </el-table-column>
              <el-table-column label="标题">
                <template>122121</template>
              </el-table-column>
              <el-table-column prop="name" label="消息内容">
              </el-table-column>
              <el-table-column prop="address" label="消息时间" show-overflow-tooltip>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 邀请新人 -->
    <InviteMember v-if="inviteDialogVisible" :visible.sync="inviteDialogVisible" @close="close"></InviteMember>
    <!-- 生成邀请链接 -->
    <InvitationDialog v-if="inviteModal" :inviteModal="inviteModal" :inviteCode="inviteCode" :inviteinfo="inviteinfo" @close="closeInvite" />
  </div>
</template>

<script>
import InviteMember from '@/components/InviteMember'
import InvitationDialog from "@/components/InvitationDialog"
import TopTitle from '@/components/TopTitle'
import { httpAjax } from "@/api/ajax"
import { GetRequest } from '@/api/config'

const imgs = {
  companyImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/companyImg.png',
  userImg: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/userImg.png',
  homePage: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/homePage2.png',
  reading: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/reading.png',
  copy: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/empty/copy.png',
}

export default {
  name: 'HomePage',
  components: {
    TopTitle,
    InviteMember,
    InvitationDialog
  },
  data () {
    return {
      imgs,
      inviteDialogVisible: false, //邀请新人
      activeName: 'first',
      msgActive: true,
      multipleSelection: [],
      tableData: [11],
      info: {},
      userData: {},

      // 邀请链接
      inviteModal: false,
      inviteinfo: null,
      inviteCode: null,
    }
  },
  mounted () {
    const inviteCode = GetRequest().inviteCode ? GetRequest().inviteCode.split('#')[0] : null
    if (inviteCode || this.$route.query.inviteCode) {
      if (inviteCode) {
        this.inviteCode = inviteCode
      } else {
        this.inviteCode = this.$route.query.inviteCode
      }
      this.getInviteInfo(this.inviteCode)
    }
    this.getInfo()
    this.getUserInfo()
  },
  methods: {
    // 问卷星
    toWjx(){
      window.open('https://www.wjx.top/vj/wqkJT7s.aspx')
    },
    // 获取用户信息
    getUserInfo () {
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.userData = response.data
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    // 添加员工
    inviteShow () {
      if (this.userData.companyStatus != 20) {
        this.$message({
          type: 'error',
          message: '请先通过企业认证'
        })
        return
      }
      if (this.info.enable != 1) {
        this.$message({
          type: 'error',
          message: '企业已被禁用，请联系客服'
        })
        return
      }

      this.inviteDialogVisible = true
    },
    // 关闭弹窗
    close () {
      this.inviteDialogVisible = false
    },
    // 复制
    copy (e) {
      this.$copyText(e)
      this.$message({
        type: 'success',
        message: '复制成功!'
      })
    },
    // 获取信息
    getInfo () {
      httpAjax({
        url: `/services/company/currentCompany`,
        method: "get",
      }).then((response) => {
        this.info = response.data
      })
    },
    // 更多成员
    goMember () {
      this.$router.push({ name: 'member' })
    },
    // 去认证
    goApprove () {
      this.$router.push({ name: 'certification' })
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // tab
    msgTab (bool) {
      this.msgActive = bool
    },
    // tab 切换
    handleClick (e) {
      console.log(e)
    },
    // 获取邀请信息
    getInviteInfo (inviteCode) {
      console.log(inviteCode)
      httpAjax({
        url: `/services/company/invite/${inviteCode}/info`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.inviteinfo = response.data
          this.inviteModal = true
        } else {
          localStorage.removeItem('inviteCode')
          // this.$message({
          //   message: response.msg,
          //   type: 'error'
          // })
        }
      })
    },
    // 关闭邀请弹窗
    closeInvite () {
      this.inviteModal = false
    },
  },
}
</script>

<style scoped lang='less'>
// #106AE7
.home-page {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 0 20px;
  /deep/ .el-tabs__header {
    margin: 0;
  }

  .name-wrapper {
    margin-left: 180px;
  }

  /deep/ .icon-a-fuzhi20:hover {
    color: #7fb6f9 !important;
  }

  .mes-tab {
    width: 88px;
    height: 38px;
    background: #fff;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    margin: 24px 0;
  }

  .mes-tab-active {
    color: #1170eb;
    background: #eff5ff;
  }

  .msg-btn {
    width: 56px;
    height: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1170eb;
    line-height: 24px;
    margin: 0 0 0px 8px;
  }

  .company-user-card:hover {
    cursor: pointer;
    .add-img {
      width: 54px;
      height: 54px;
      background-image: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/add2.png");
    }
    .txt-hover {
      color: #1170eb;
    }
  }

  .company-user-card {
    margin: 32px 48px 0 0;
    .add-img {
      width: 54px;
      height: 54px;
      background-image: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/user/info/add1.png");
      background-size: 100%;
    }

    .txt {
      width: 56px;
      height: 20px;
      font-size: 14px;
      // font-weight: 500;
      color: #222222;
      line-height: 20px;
      margin-top: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .more {
    width: 56px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1170eb;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    .dian {
      width: 10px;
      height: 10px;
      background: #ff1212;
      border-radius: 50%;
      position: absolute;
      top: -6px;
      right: -3px;
    }
  }

  .home-page-tab {
    /deep/ .is-active {
      color: #106ae7 !important;
    }
    /deep/ .el-tabs__active-bar {
      background: #106ae7 !important;
    }
    /deep/ .el-tabs__item {
      font-size: 18px;
    }
    /deep/ .el-tabs__item:hover {
      font-size: 18px;
      color: #106ae7 !important;
    }
  }

  .company-msg {
    /deep/ .el-empty__image {
      width: 56px;
      height: 56px;
    }

    .top-div {
      margin: 32px 0 32px 0;
    }
    .center-div {
    }
    .content-div {
      height: 168px;
    }
    .bottom-img {
      width: 1600px;
      margin-bottom: 76px;
      margin-top: 48px;
      position: relative;
      .btn {
        position: absolute;
        left: 239px;
        top: 166px;
        background: #1170eb;
        border: 0;
        color: #fff;
        box-shadow: 0px 2px 4px 0px rgba(17, 112, 235, 0.31);
      }
      .btn:hover {
        background: #66b1ff;
        border: 0;
      }
    }

    .line-div {
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: #f7f7fa;
      border-radius: 4px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      padding-left: 16px;
    }

    .pic-div {
      border-radius: 4px;
      overflow: hidden;
      width: 76px;
      height: 76px;
      position: relative;
      .update-div {
        display: none;
        width: 76px;
        height: 20px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 0px 0px 4px 4px;
        position: absolute;
        bottom: 0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
    }

    .info {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000;
      .title-small {
        margin: 0 180px 24px 32px;
        color: #666666;
        text-align: right;
        width: 56px;
      }
      .text-content {
        width: 196px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
      .approve {
        color: #1170eb;
        margin-left: 180px;
        cursor: pointer;
      }
    }
  }
}
</style>
